<template>
  <div class="tagViews">
    <router-link
      v-for="tag in visitedViews"
      ref="tag"
      :key="tag.path"
      :class="isActive(tag) ? 'active' : ''"
      :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
      tag="span"
      class="item"
    >
      {{ tag.title }}
      <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "TagViews",
  props: {},
  computed: {},
  data() {
    return {
      visitedViews: [],
    };
  },
  watch: {
    $route() {
      this.addTags();
    },
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path;
    },
    addTags() {
      //增加页签
      if (this.visitedViews.some((i) => i.path === this.$route.path)) return;
      this.visitedViews.push({
        title: this.$route.meta.title || "no-name",
        path: this.$route.path,
      });
    },
    closeSelectedTag(tag) {
      //删除页签
      if (this.visitedViews.length == 1) return; //禁止删除最后一个页签
      this.visitedViews = this.visitedViews.filter((i) => i.path !== tag.path);
      if (this.isActive(tag)) {
        this.$router.push(this.visitedViews[this.visitedViews.length - 1].path);
      }
    },
  },
  mounted() {
    this.addTags();
  },

  created() {},
};
</script>


<style lang="scss" scoped>
.tagViews {
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 10px 0px 10px 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  position: fixed;
  z-index: 100;
  background-color: white;
  .item {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 26px;
    line-height: 26px;
    border: 1px solid #d8dce5;
    color: #495060;
    background: #fff;
    padding: 0 8px;
    font-size: 12px;
    margin-left: 5px;
    margin-top: 4px;
    &.active {
      background-color: #42b983;
      color: #fff;
      border-color: #42b983;
      &::before {
        content: "";
        background: #fff;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: relative;
        margin-right: 2px;
      }
    }
    .el-icon-close {
      &:hover {
        transform: scale(1.2);
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
